/**
 * Product object
 * @param {object} product cart data
 * @param {object} order order object
 * @returns {object} product object with data
 * @todo Complete missing data
 */
export default (product, order) => ({
	campaign: order.campaign,
	campaignMarker: order.campaignMarker || '',
	name: '-', // should be universal us product name
	localName: product.name,
	sku: product.sku,
	productId: product.id,
	maintenance: 0, // @todo should be AR months
	seats: product.contentGroup === 'Consumer' ? product.devices : product.quantity,
	quantity: product.quantity,
	currencyCode: order.currency,
	category: product.category.string,
	price: 0, // @todo pricing portal data required
	tax: 0, // @todo pricing portal data required
	brand: order.brand,
	os: '-', // @todo pricing portal data required
	localCurrencyCode: order.currency,
	localPrice: product.price.street.unformatted || 0,
	localTax: product.price.tax.unformatted || 0,
	discount: 0, // @todo pricing portal data required
	localDiscount: order.price.discount.absolute.unformatted || 0
});
